(() => {
  const roots = document.querySelectorAll('[data-fds-galenica]');

  roots.forEach((root) => {
    const search = root.querySelector('[data-fds-search]');
    const cards = Array.from(root.querySelectorAll('[data-fds-card]'));
    const typeGroup = root.querySelector('[data-fds-type]');
    const prescriptionGroup = root.querySelector('[data-fds-prescription]');
    const prescriptionBlock = root.querySelector('[data-fds-prescription-block]');
    const areaGroup = root.querySelector('[data-fds-area]');
    const count = root.querySelector('[data-fds-result-count]');
    const reset = root.querySelector('[data-fds-reset]');
    const empty = root.querySelector('[data-fds-empty]');

    if (!cards.length) return;

    const state = { type: 'preparazione', prescription: 'all', area: 'all', query: '' };

    const normalize = (value) => (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const setActive = (group, value) => {
      if (!group) return;
      group.querySelectorAll('button[data-value]').forEach((button) => {
        const active = button.dataset.value === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const updateContextControls = () => {
      const technologyMode = state.type === 'tecnologia';
      if (prescriptionBlock) prescriptionBlock.hidden = technologyMode;
      if (technologyMode && state.prescription !== 'all') {
        state.prescription = 'all';
        setActive(prescriptionGroup, 'all');
      }
    };

    const resultLabel = (visible) => {
      if (state.type === 'preparazione') return `${visible} ${visible === 1 ? 'preparazione' : 'preparazioni'}`;
      if (state.type === 'attivo') return `${visible} ${visible === 1 ? 'principio attivo' : 'principi attivi'}`;
      return `${visible} ${visible === 1 ? 'base / tecnologia' : 'basi / tecnologie'}`;
    };

    const apply = () => {
      updateContextControls();
      let visible = 0;
      const query = normalize(state.query);

      cards.forEach((card) => {
        const kindMatch = card.dataset.kind === state.type;
        const prescriptionMatch = state.type === 'tecnologia' || state.prescription === 'all' || card.dataset.prescription === state.prescription;
        const areas = (card.dataset.area || '').split(/\s+/).filter(Boolean);
        const areaMatch = state.area === 'all' || areas.includes(state.area);
        const searchMatch = !query || normalize(card.textContent).includes(query);
        const show = kindMatch && prescriptionMatch && areaMatch && searchMatch;

        card.hidden = !show;
        if (show) visible += 1;
      });

      if (count) count.textContent = resultLabel(visible);
      if (empty) empty.hidden = visible !== 0;
    };

    const wireGroup = (group, key) => {
      if (!group) return;
      group.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-value]');
        if (!button) return;
        state[key] = button.dataset.value;
        setActive(group, state[key]);
        apply();
      });
    };

    wireGroup(typeGroup, 'type');
    wireGroup(prescriptionGroup, 'prescription');
    wireGroup(areaGroup, 'area');

    if (search) {
      search.addEventListener('input', () => {
        state.query = search.value;
        apply();
      });
    }

    if (reset) {
      reset.addEventListener('click', () => {
        state.type = 'preparazione';
        state.prescription = 'all';
        state.area = 'all';
        state.query = '';
        if (search) search.value = '';
        setActive(typeGroup, state.type);
        setActive(prescriptionGroup, state.prescription);
        setActive(areaGroup, state.area);
        apply();
      });
    }

    apply();
  });
})();
